Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _amplifyStore = require('amplify-store');

var _amplifyStore2 = _interopRequireDefault(_amplifyStore);

var _EventLogger = require('./EventLogger');

var _EventLogger2 = _interopRequireDefault(_EventLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tracking = function () {
  function Tracking() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Tracking);

    this.options = options;
    this.initialized = false;
    this.initializers = [];
    if (options.logger) {
      this.setLogger(options.logger);
    }
  }

  _createClass(Tracking, [{
    key: 'setLogger',
    value: function () {
      function setLogger(loggerOptions) {
        this._logger = new _EventLogger2['default'](loggerOptions);
      }

      return setLogger;
    }()
  }, {
    key: 'getLogger',
    value: function () {
      function getLogger() {
        if (this._logger == null) {
          throw new Error('[tracking-js] Please provide a logger config, either in the constructor or using `setLogger()`.');
        }
        return this._logger;
      }

      return getLogger;
    }()
  }, {
    key: 'init',
    value: function () {
      function init() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.options = Object.assign(this.options, { rum: true }, options);
        this.initializers.forEach(function (fn) {
          return fn(_this.options);
        });
        this.initialized = true;
        this.initializers = [];
        this.addInitHook(function () {
          return _this.getLogger().flushEventQueue();
        });
      }

      return init;
    }()
  }, {
    key: 'addInitHook',
    value: function () {
      function addInitHook(initFn) {
        if (!this.initialized) {
          this.initializers.push(initFn);
        } else {
          initFn(this.options);
        }
      }

      return addInitHook;
    }()

    /*
     setUiRef: Sets a key in local storage of the ui element that
     the user clicked on.
      referrerKey - a key to represent the dom element clicked on (required)
     el - the dom element that contains the href (optional)
     */

  }, {
    key: 'setUiRef',
    value: function () {
      function setUiRef(referrerKey, el) {
        (0, _amplifyStore2['default'])('uiReferrer', referrerKey);
        if (el) {
          window.location.href = el.getAttribute('href');
        }
      }

      return setUiRef;
    }()

    /*
     getUiRef: checks for existence of a value in localStorage key `uiReferrer`,
     if it exists, it returns value and deletes the key/value.
     */

  }, {
    key: 'getUiRef',
    value: function () {
      function getUiRef() {
        var uiRef = (0, _amplifyStore2['default'])('uiReferrer');
        if (uiRef) {
          (0, _amplifyStore2['default'])('uiReferrer', null);
        }
        return uiRef;
      }

      return getUiRef;
    }()
  }, {
    key: 'clearContext',
    value: function () {
      function clearContext() {
        this.getLogger().clearContext();
      }

      return clearContext;
    }()
  }, {
    key: 'addContext',
    value: function () {
      function addContext(context) {
        this.getLogger().addContext(context);
      }

      return addContext;
    }()
  }, {
    key: 'addDefaultContext',
    value: function () {
      function addDefaultContext() {
        this.getLogger().addDefaultContext();
      }

      return addDefaultContext;
    }()
  }, {
    key: 'onPageURIChange',
    value: function () {
      function onPageURIChange(callback) {
        this.getLogger().onPageURIChange(callback);
      }

      return onPageURIChange;
    }()
  }, {
    key: 'airdogBump',
    value: function () {
      function airdogBump(key, count, tags, queue) {
        this.getLogger().airdogBump(key, count, tags, queue);
      }

      return airdogBump;
    }()
  }, {
    key: 'logAirdogEvent',
    value: function () {
      function logAirdogEvent(data) {
        this.getLogger().logAirdogEvent(data);
      }

      return logAirdogEvent;
    }()
  }, {
    key: 'logEvent',
    value: function () {
      function logEvent(e) {
        this.getLogger().logEvent(e);
      }

      return logEvent;
    }()
  }, {
    key: 'logJitneyEvent',
    value: function () {
      function logJitneyEvent(e) {
        this.getLogger().logJitneyEvent(e);
      }

      return logJitneyEvent;
    }()
  }, {
    key: 'queueEvent',
    value: function () {
      function queueEvent(e) {
        this.getLogger().queueEvent(e);
      }

      return queueEvent;
    }()
  }, {
    key: 'queueJitneyEvent',
    value: function () {
      function queueJitneyEvent(e) {
        this.getLogger().queueJitneyEvent(e);
      }

      return queueJitneyEvent;
    }()
  }]);

  return Tracking;
}();

exports['default'] = Tracking;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/Tracking.js
// module id = 472
// module chunks = 168707334958949